import * as React from 'react';

import { ProjectList } from '../../../../components/ProjectList';
import { IProject } from '../../models';

interface IProps {
    projects: IProject[];
}

export const NextProjects: React.FC<IProps> = ({
    projects
}) => (
        Boolean(projects.length) ? (
            <div className="nextProjects">
                <div className="nextProjects__title">
                    <h2>Next projects</h2>
                </div>
                <ProjectList
                    projects={projects}
                />
            </div>
        ) : null
    );
